import { IProductCarousel } from '../../types/IProductCarousel';
import tagDocs03 from '../assets/product-screens/tagdocs-03.jpg';
import tagDocs04 from '../assets/product-screens/tagdocs-04.jpg';

export const docTagProduct: IProductCarousel = {
  steps: [
    {
      title: 'Edit Documents',
      imageUrl: tagDocs03,
      points: [
        {
          title: '',
          description:
            'On the right side of your screen, you will see a list of form field choices, such as Signature, Textbox, Initials, etc., to drag and drop into your document. Be sure to choose the correct Assignee from the drop-down menu. You can also upload a new document and add additional form fields.',
        },
      ],
    },
    {
      title: 'Submitting',
      imageUrl: tagDocs04,
      points: [
        {
          title: '',
          description:
            'Click SEND to submit the document package to your parties (signers), who can now review and sign all ancillary documents that do not require the presence of a Notary.',
        },
      ],
    },
  ],
};
